import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Check, ArrowRight } from 'lucide-react';
import { targetAudienceData } from '../mockData';

export const AudienceSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="audience" className="py-24 bg-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Built for Industry Leaders
          </h2>
          <div className="w-20 h-1 bg-red-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Whether you manufacture trucks or operate fleets, our solution delivers immediate value
          </p>
        </div>

        {/* Audience Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {targetAudienceData.map((audience) => (
            <Card 
              key={audience.id}
              className="bg-white border-gray-200 hover:border-red-600 hover:shadow-xl transition-all duration-300 group"
            >
              <CardHeader className="pb-6">
                <CardTitle className="text-3xl text-gray-900 mb-3 group-hover:text-red-600 transition-colors duration-300">
                  {audience.title}
                </CardTitle>
                <CardDescription className="text-gray-600 text-lg leading-relaxed">
                  {audience.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                {/* Benefits List */}
                <ul className="space-y-4 mb-8">
                  {audience.benefits.map((benefit, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <div className="flex-shrink-0 w-6 h-6 bg-red-100 rounded-full flex items-center justify-center mt-0.5">
                        <Check className="text-red-600" size={16} />
                      </div>
                      <span className="text-gray-700">{benefit}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <Button 
                  onClick={scrollToContact}
                  className="w-full bg-red-600 hover:bg-red-700 text-white transition-all duration-200 group/btn"
                  size="lg"
                >
                  {audience.cta}
                  <ArrowRight className="ml-2 group-hover/btn:translate-x-1 transition-transform" size={18} />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Info Section */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gray-50 border border-gray-200 rounded-xl px-8 py-6 max-w-4xl">
            <p className="text-gray-700 text-lg">
              Our system is the <span className="text-red-600 font-semibold">last inch solution</span> for autonomous trucking, 
              enabling fully automated operations from depot to highway and back.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
